'use client'

import { init, push } from '@socialgouv/matomo-next';
import { usePathname } from 'next/navigation';
import { useEffect, useRef, useState } from 'react';

export function MatomoAnalytics() {
  const pathname = usePathname();
  const isInitialLoad = useRef(true);

  const [url, setUrl] = useState<string>("");
  const [siteId, setSiteId] = useState<number>(0);

  useEffect(() => {
    if (!(url === "" && siteId === 0)) {
      return;
    }

    fetch('/api/matomo-config')
      .then(res => {
        if (!res.ok) {
          return;
        }
        return res.json()
      })
      .then(resBody => {
        if (!resBody) return;

        let matomoUrl = resBody.url;
        let matomoSiteId = resBody.siteId;

        setUrl(matomoUrl);
        setSiteId(matomoSiteId);
      })
  }, []);

  useEffect(() => {
    if (url === "" || siteId === 0) {
      return;
    }

    init({ url, siteId: siteId.toString() });
    return () => push(['HeatmapSessionRecording::disable']);
  }, [url, siteId]);

  useEffect(() => {
    if (isInitialLoad.current) {
      isInitialLoad.current = false;

    } else {
      if (pathname) {
        push(['setCustomUrl', pathname]);
        push(['trackPageView']);
      }
    }
  }, [pathname])

  return null
}
